import { useEffect } from "react";
import { matchPath, useLocation } from "react-router";
import { trackScreenView } from "../lib/analytics";

// App.tsx の <Route path="..."> と同じパターンを定義
// 具体パス → テンプレートの順に並べる（/items/new が /items/:id より先）
const ROUTE_PATTERNS = [
  "/",
  "/home",
  "/items/new",
  "/items/:id",
  "/settings",
  "/groups/new",
  "/groups/join",
  "/groups/:id",
  "/login",
  "/login/email",
  "/auth/line/callback",
  "/contact",
  "/paywall",
  "/admin",
  "/privacy",
];

function getScreenName(pathname: string): string | null {
  for (const pattern of ROUTE_PATTERNS) {
    if (matchPath(pattern, pathname)) {
      return pattern;
    }
  }
  return null;
}

export function useScreenTracking(): void {
  const location = useLocation();

  useEffect(() => {
    const screenName = getScreenName(location.pathname);
    if (screenName) {
      trackScreenView(screenName);
    }
  }, [location.pathname]);
}
